const usePagination = ({ limit, setOffset, setPage, setLimit }) => {
  const handleChangePage = (event, newPage) => {
    setOffset(newPage * limit);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setLimit(parseInt(event.target.value, 10));
    setOffset(0);
    setPage(0);
  };

  return { handleChangePage, handleChangeRowsPerPage };
};

export default usePagination;
